export default __webpack_public_path__ + "0969b62.png";